import { Component, EventEmitter, Output } from '@angular/core';
import {
  SezioneEconomicaFondoOneriFormComponent
} from '../../../form/sez-economica/sezione-economica-fondo-oneri-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FondoOnere } from '../../../models/fondo-onere';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
    selector: 'div [sezione-economica-fondo-oneri-form-update]',
  templateUrl: '../../../form/sez-economica/sezione-economica-fondo-oneri-form.component.html'
})

export class SezioneEconomicaFondoOneriUpdateComponent extends SezioneEconomicaFondoOneriFormComponent {
  fondoOnere: FondoOnere;
  urlUpdate: string;
  urlReadSezioneEconomica: string;
  urlReadSezioneLegali: string;

  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  ngOnInit() {
    this.setTitle('Modifica Fondo Onere');
    this.isInserimento(false);
  }

  getFondoOnere() {
    return this.fondoOnere;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getRequest(request: FondoOnere) {
    this.operationService.updateFondoOneri(this.urlUpdate, request, this.sezione.id).subscribe((response: any) => this.datiSezioneEconomica(response));
  }

  datiSezioneEconomica(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica,
              fondoOnere: FondoOnere,
              fascicolo: FascicoloFull,
              urlUpdate: string,
              urlReadSezioneEconomica: string,
              urlReadSezioneLegali: string) {
    this.fondoOnere = fondoOnere;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.readSezioneEconomica(fascicolo.idSezioneDatiEconomici);
    this.readSezioneLegali(fascicolo.idSezioneLegali);
    this.createForm();
    this.populateSelect();
  }

}
